import * as React from 'react';
import { InlineText1, LinkButton, useDeviceType } from '@cian/ui-kit';

import { Wrapper } from '../Wrapper';
import { trackGoToFormClick } from '../../containers/PageContainer/trackings';
import { PromoPrice } from '../PromoPrice';

import * as styles from './styles.css';

export interface IHeroProps {
  price: string;
  buyLink: string;
  promoPriceText?: string | null;
  oldPrice?: string | null;
  termsOfPromotion?: string | null;
}

export const Hero: React.FC<IHeroProps> = props => {
  const isDesktop = useDeviceType() === 'desktop';
  const trackActionBtnClick = React.useCallback(() => trackGoToFormClick('hero'), []);
  const { price, buyLink, promoPriceText, oldPrice, termsOfPromotion } = props;
  const hasPromo = Boolean(promoPriceText && oldPrice);
  const buttonText = hasPromo ? 'Проверить недвижимость' : `Проверить недвижимость за ${price}`;

  return (
    <div className={styles['container']}>
      <div className={styles['photo']}></div>
      <div className={styles['content']}>
        <Wrapper>
          <div className={styles['content-wrapper']}>
            <div className={styles['title-area']}>
              <h1 className={styles['title']}>Проверьте недвижимость</h1>
              <span className={styles['sub-title']}> перед покупкой, чтобы избежать неприятных сюрпризов</span>
            </div>
            <div className={styles['description-area']}>
              <InlineText1 color="white_100">
                Юристы изучат объект и продавца, расскажут о возможных рисках и помогут их избежать
              </InlineText1>
            </div>
            <div className={styles['action']}>
              <LinkButton
                href={buyLink}
                onClick={trackActionBtnClick}
                theme="fill_white_primary"
                size="L"
                fullWidth={!isDesktop}
              >
                {buttonText}
              </LinkButton>
              {hasPromo && (
                <div className={styles['promo-text']}>
                  <PromoPrice
                    promoPriceText={promoPriceText as string}
                    price={price}
                    oldPrice={oldPrice as string}
                    termsOfPromotion={termsOfPromotion as string}
                  />
                </div>
              )}
            </div>
          </div>
        </Wrapper>
      </div>
    </div>
  );
};

Hero.displayName = 'Hero';
